import { atom, useAtomValue } from 'jotai';
import type { Debtor } from 'types/store/client-state';

type DebtorAtom = {
  debtor: Debtor;
  refetch: () => void;
};

export const debtorAtom = atom<DebtorAtom>({
  debtor: null as unknown as Debtor,
  refetch: () => {},
});

export const useDebtor = () => {
  const { debtor } = useAtomValue(debtorAtom);
  return debtor;
};
